import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { take } from 'rxjs/operators/take';

import { AuthService } from '@app/services';
import { DEFAULT_ROUTE } from '@app/Common';
import { isImpersonated } from '@utils/helpers/impersonation';
import { environment } from '@env/environment';

@Component({
	selector: 'impersonation-error',
	templateUrl: './impersonation-error.component.html',
	styleUrls: ['./impersonation-error.component.scss'],
})
export class ImpersonationErrorComponent implements OnInit {
	public showLoader: boolean = true;

	constructor(private router: Router, private authService: AuthService, @Inject(DOCUMENT) private document: Document) {}

	ngOnInit(): void {
		this.authService.isAuthenticated$.pipe(take(1)).subscribe(isAuthenticated => {
			if (!environment.is_pam_console || (isAuthenticated && isImpersonated)) {
				this.router.navigate([DEFAULT_ROUTE]);
			}
		});
	}
}
